import React from "react";
import SubcatPageDesk from "./SubcategoryPage/SubcatPageDesk";
import "../Desktop.css";

const SubcategoryPage = () => {
  return <SubcatPageDesk />;
};

export default SubcategoryPage;